/* Typography.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"],
  _excluded13 = ["as", "style"],
  _excluded14 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _46 = "@media (min-width:48rem){._1s18oqnp{font-size:.75rem}._17gq1cby{line-height:1.125rem}}";
const _45 = "._vwz41j6v{line-height:1rem}";
const _44 = "._1wybud5o{font-size:.625rem}";
const _43 = "@media (min-width:64rem){._3p1c1knc{font-size:var(--mp-pullquote-large-font-size-md,2.25rem)}._py5ov4nf{line-height:var(--mp-pullquote-large-line-height-md,3rem)}._duivowjs{font-weight:300}}";
const _42 = "@media (min-width:48rem){._1s18viql{font-size:2rem}._17gqyn4p{line-height:2.75rem}}";
const _41 = "._vwz48pqr{line-height:2.5rem}";
const _40 = "._1wyb1m1q{font-size:1.75rem}";
const _39 = "._k48pb4wl{font-weight:100}";
const _38 = "@media (min-width:64rem){._3p1c1ryw{font-size:var(--mp-pullquote-small-font-size-md,1.75rem)}._py5o18o1{line-height:var(--mp-pullquote-small-line-height-md,2.5rem)}}";
const _37 = "@media (min-width:48rem){._1s181k8s{font-size:1.5rem}._17gqviql{line-height:2rem}}";
const _36 = "._vwz41f4h{line-height:28px}";
const _35 = "._k48powjs{font-weight:300}";
const _34 = "@media (min-width:64rem){._3p1c1qiz{font-size:var(--mp-body-large-font-size-md,1.25rem)}._py5o1r6l{line-height:var(--mp-body-large-line-height-md,1.75rem)}}";
const _33 = "._vwz41tcg{line-height:24px}";
const _32 = "._vwz4gktf{line-height:20px}";
const _31 = "._ect4po1d{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}";
const _30 = "._vwz4f6fq{line-height:18px}";
const _29 = "._1wyboxwj{font-size:.875rem}";
const _28 = "._vwz47vkz{line-height:1pc}";
const _27 = "._1wyboqnp{font-size:.75rem}";
const _26 = "._1p1dangw{text-transform:uppercase}";
const _25 = "._1p1dglyw{text-transform:none}";
const _24 = "._vwz41k8s{line-height:1.5rem}";
const _23 = "._1wyb1j6v{font-size:1rem}";
const _22 = "@media (min-width:64rem){._3p1c1uvp{font-size:var(--mp-h5-font-size-md,1.25rem)}._py5o1nsk{line-height:var(--mp-h5-line-height-md,1.75rem)}}";
const _21 = "._1wyb1cby{font-size:1.125rem}";
const _20 = "@media (min-width:64rem){._3p1c1lzw{font-size:var(--mp-h4-font-size-md,1.5rem)}._py5o1ds4{line-height:var(--mp-h4-line-height-md,1.875rem)}}";
const _19 = "@media (min-width:48rem){._1s18imiu{font-size:1.375rem}._17gq1m1q{line-height:1.75rem}}";
const _18 = "._vwz41slo{line-height:1.625rem}";
const _17 = "._1wyb1k92{font-size:1.25rem}";
const _16 = "@media (min-width:64rem){._3p1c1kjp{font-size:var(--mp-h3-font-size-md,2rem)}._py5o1nre{line-height:var(--mp-h3-line-height-md,2.375rem)}}";
const _15 = "@media (min-width:48rem){._1s181m1q{font-size:1.75rem}._17gqc5mb{line-height:2.125rem}}";
const _14 = "._1dyzdrct{letter-spacing:.01875rem}";
const _13 = "._vwz4l07h{line-height:1.875rem}";
const _12 = "._1wyb1k8s{font-size:1.5rem}";
const _11 = "@media (min-width:64rem){._3p1c1ihe{font-size:var(--mp-h2-font-size-md,2.5rem)}._py5o18a8{line-height:var(--mp-h2-line-height-md,3rem)}}";
const _10 = "@media (min-width:48rem){._1s18ahaf{font-size:2.25rem}._17gq13ei{line-height:2.625rem}}";
const _9 = "._vwz411uf{line-height:2.375rem}";
const _8 = "._1wybviql{font-size:2rem}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "@media (min-width:64rem){._3p1cne5d{font-size:var(--mp-h1-font-size-md,3rem)}._py5o1qiw{line-height:var(--mp-h1-line-height-md,3.5rem)}}";
const _6 = "@media (min-width:48rem){._1s18yn4p{font-size:2.75rem}._17gqqf5o{line-height:3.25rem}}";
const _5 = "._k48pni7l{font-weight:600}";
const _4 = "._vwz41p2n{line-height:2.875rem}";
const _3 = "._1wyb8pqr{font-size:2.5rem}";
const _2 = "._ect42gy8{font-family:var(--ds-font-family-brand-heading,\"Charlie Display\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}";
const _ = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const baseStyles = {
  color: "var(--ds-text, #172B4D)"
};
const H1 = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "h1",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1wyb8pqr _vwz41p2n _k48pni7l _1s18yn4p _17gqqf5o _3p1cne5d _py5o1qiw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  H1.displayName = 'H1';
}
const H2 = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "h2",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _8, _9, _5, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1wybviql _vwz411uf _k48pni7l _1s18ahaf _17gq13ei _3p1c1ihe _py5o18a8", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  H2.displayName = 'H2';
}
const H3 = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "h3",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _12, _13, _5, _14, _15, _16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1wyb1k8s _vwz4l07h _k48pni7l _1dyzdrct _1s181m1q _17gqc5mb _3p1c1kjp _py5o1nre", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  H3.displayName = 'H3';
}
const H4 = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "h4",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _17, _18, _5, _14, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1wyb1k92 _vwz41slo _k48pni7l _1dyzdrct _1s18imiu _17gq1m1q _3p1c1lzw _py5o1ds4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  H4.displayName = 'H4';
}
const H5 = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "h5",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _21, _18, _5, _14, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1wyb1cby _vwz41slo _k48pni7l _1dyzdrct _3p1c1uvp _py5o1nsk", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  H5.displayName = 'H5';
}
const H6 = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "h6",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _23, _24, _5, _14, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1wyb1j6v _vwz41k8s _k48pni7l _1dyzdrct _1p1dglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  H6.displayName = 'H6';
}
const EyebrowSmall = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _26, _27, _28]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1p1dangw _1wyboqnp _vwz47vkz", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  EyebrowSmall.displayName = 'EyebrowSmall';
}
const EyebrowMedium = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _26, _29, _30]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1p1dangw _1wyboxwj _vwz4f6fq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  EyebrowMedium.displayName = 'EyebrowMedium';
}
const BodySmall = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _31, _29, _32]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect4po1d _1wyboxwj _vwz4gktf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BodySmall.displayName = 'BodySmall';
}
const BodyNormal = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _31, _23, _33]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect4po1d _1wyb1j6v _vwz41tcg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BodyNormal.displayName = 'BodyNormal';
}
const BodyLarge = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _21, _18, _34]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _1wyb1cby _vwz41slo _3p1c1qiz _py5o1r6l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BodyLarge.displayName = 'BodyLarge';
}
const PullQuoteSmall = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _35, _17, _36, _37, _38]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _k48powjs _1wyb1k92 _vwz41f4h _1s181k8s _17gqviql _3p1c1ryw _py5o18o1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PullQuoteSmall.displayName = 'PullQuoteSmall';
}
const PullQuoteLarge = forwardRef((_ref13, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref13,
    __cmplp = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _39, _40, _41, _42, _43]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect42gy8 _k48pb4wl _1wyb1m1q _vwz48pqr _1s18viql _17gqyn4p _3p1c1knc _py5ov4nf _duivowjs", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PullQuoteLarge.displayName = 'PullQuoteLarge';
}
const FinePrint = forwardRef((_ref14, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref14,
    __cmplp = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _31, _44, _45, _46]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1fxt _ect4po1d _1wybud5o _vwz41j6v _1s18oqnp _17gq1cby", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FinePrint.displayName = 'FinePrint';
}
const Eyebrow = _ref15 => {
  let {
    size,
    children
  } = _ref15;
  switch (size) {
    case 'small':
      return /*#__PURE__*/_jsx(EyebrowSmall, {
        children: children
      });
    case 'medium':
      return /*#__PURE__*/_jsx(EyebrowMedium, {
        children: children
      });
  }
};
const PullQuote = _ref16 => {
  let {
    size,
    children
  } = _ref16;
  switch (size) {
    case 'small':
      return /*#__PURE__*/_jsx(PullQuoteSmall, {
        children: children
      });
    case 'large':
      return /*#__PURE__*/_jsx(PullQuoteLarge, {
        children: children
      });
  }
};
export { BodyLarge, BodyNormal, BodySmall, Eyebrow, EyebrowMedium, EyebrowSmall, FinePrint, H1, H2, H3, H4, H5, H6, PullQuote };

/*
  Though we have started using @compiled/react, we are not using it in a perfect way.
  We are still following the styled components way of writing css that is having some limitations like:
  - component composition doesn't work
  - functions interpolation doesn't work. Explicitly declaring the rule name is required.
  Also, the recommended way of using @compiled/react is to use the css prop. But we are not using it.
  We might have to relook our way of writing css with @compiled/react in future.
  More details inside -> https://ecosystem.atlassian.net/browse/MC-4428
*/

// const BodySmallStyles = {
//   fontSize: '0.875rem',
//   lineHeight: '20px',
// };

// const Body = ({
//   size,
//   children,
//   style,
//   className,
// }: {
//   size: string;
//   children: ReactNode;
//   style?: any;
//   className?: any;
// }) => {
//   switch (size) {
//     case 'small':
//       return (
//         <ClassNames>
//           {({ css }) => (
//             <p
//               style={style}
//               className={ax([css(BodySmallStyles), css(charlieDisplayFontFamily), className])}
//             >
//               {children}
//             </p>
//           )}
//         </ClassNames>
//       );
//     case 'medium':
//       return <BodyMedium>{children}</BodyMedium>;
//     case 'large':
//       return <BodyLarge>{children}</BodyLarge>;
//   }
// };